export default __webpack_public_path__ + "static/media/badges.480ca43a.png";